var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-snackbar',_vm._g(_vm._b({attrs:{"color":"#DCE1F3"}},'v-snackbar',_vm.$attrs,false),_vm.$listeners),[_c('div',{staticClass:"d-flex align-center"},[_c('v-icon',{attrs:{"color":_vm.icon_color}},[_vm._v(_vm._s(_vm.icon))]),_c('span',{staticClass:"ml-4",class:_vm.$style.messageText},[_vm._v(_vm._s(_vm.message))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }